import api from 'api';

export const loadMarketingPlanningGrid = api(
  'GET /api/marketing-planning/grid'
);
export const createMarketingPlan = api('POST /api/marketing-planning');
export const loadMarketingPlanningHistory = api(
  'GET /api/marketing-planning/:year/:month/history'
);

export const discardMarketingPlan = api(
  'POST /api/marketing-planning/:year/:month/discard'
);
export const restoreMarketingPlan = api(
  'POST /api/marketing-planning/:year/:month/:version/restore'
);

export const importGoogleDrive = api(
  'POST /api/marketing-planning/:year/:month/import-google-drive'
);
export const importCSV = async ({ file, year, month }) => {
  return await api(`POST /api/marketing-planning/${year}/${month}/csv`)(file);
};
export const importNewCSV = api('POST /api/marketing-planning/csv');

export const checkLoadStatus = api('GET /api/marketing-planning/:jobId/status');
export const downloadResultFile = api(
  'GET /api/marketing-planning/:jobId/file'
);
export const loadFileId = api('GET /api/marketing-planning/:jobId/drive');
export const importNewFromGoogleDrive = api(
  'POST /api/marketing-planning/import-google-drive'
);
export const exportFromGoogleDrive = api(
  'GET /api/marketing-planning/:year/:month/export-google-drive'
);
export const exportCSV = api('GET /api/marketing-planning/:year/:month/csv', {
  responseType: 'blob',
});
export const loadErrorLog = api(
  'GET /api/marketing-planning/:year/:month/error-log'
);
